import React from "react";

import { profileFileUpload, useUserContext } from "utils";

import { USER_TITLE } from "consts";

import { Col, Form, Input, KlimRadioGroup, Row, TextArea, Typography, UploadImage } from "components";

type ProfileUpdatePublicProps = {
  details: { bio?: string };
  imageSuccess: boolean;
  imageURL: string;
  setImageSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setImageURL: React.Dispatch<React.SetStateAction<string>>;
  t: (key: string) => string;
};

export const ProfileUpdatePublic = ({ details, imageSuccess, imageURL, setImageSuccess, setImageURL, t }: ProfileUpdatePublicProps) => {
  const { user } = useUserContext();
  if (!user) return null;

  return (
    <>
      <Row className="margin-top-400">
        <Col>
          <Typography variant="h2">{t("profileUpdate.publicData.title")}</Typography>
        </Col>
      </Row>
      <Row className="margin-top-200">
        <Col sm={24} md={24}>
          <Form.Item name="title" rules={[{ required: true }]} initialValue={user.title}>
            <KlimRadioGroup
              options={[
                { label: t(`profileUpdate.publicData.inputs.title.${USER_TITLE.MR}`), value: USER_TITLE.MR },
                { label: t(`profileUpdate.publicData.inputs.title.${USER_TITLE.MRS}`), value: USER_TITLE.MRS },
                { label: t(`profileUpdate.publicData.inputs.title.${USER_TITLE.OTHER}`), value: USER_TITLE.OTHER },
              ]}
            />
          </Form.Item>
        </Col>
        <Col sm={12} md={12}>
          <Input name="firstName" label={t("profileUpdate.publicData.inputs.firstName")} rules={[{ required: true }]} initialValue={user.firstName} />
        </Col>
        <Col sm={12} md={12}>
          <Input name="lastName" label={t("profileUpdate.publicData.inputs.lastName")} rules={[{ required: true }]} initialValue={user.lastName} />
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={18}>
          <TextArea
            name="bio"
            label={t("profileUpdate.publicData.inputs.bio")}
            rules={[{ required: false }]}
            initialValue={details.bio}
            autoSize={{ minRows: 3 }}
          />
        </Col>
        <Col sm={24} md={6}>
          <Form.Item name={"image"} rules={[{ required: false }]}>
            <UploadImage
              // @ts-expect-error convert to TS
              beforeUpload={(file) => profileFileUpload(file, setImageSuccess, setImageURL, t, false)}
              id="file-upload"
              imageSuccess={imageSuccess}
              imageUrl={imageURL}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
